module.exports = __webpack_public_path__ + "img/55_41.686a9c29.png";